import ReactDOM from 'react-dom/client';
import { TenantContext } from '../../../context/tenant-context';
import { UsersReport } from './users-report';
import { v2Component } from '../../../index';

export function initRentersReport() {
  document.getElementsByName('users-report').forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);

      const bootstrap = () => {
        const { tenant, contextPath } = Object.assign({}, element.dataset) as any;
        root.render(
          v2Component(
            <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
              <UsersReport />
            </TenantContext.Provider>,
          ),
        );
      };

      bootstrap();
    }
  });
}
